import * as React from "react";
import { useState, useCallback } from "react";
import { Col, Row, Table } from "components/bootstrap";
import PaginatedList from "components/common/PaginatedList";
import SearchForm from "components/common/SearchForm";
import Spinner from "components/common/Spinner";
import useUserSearchFiltersQuery from "search-filter/hooks/useUserSearchFiltersQuery";
import QueryHelper from "components/common/QueryHelper";
import { FILTER_SCOPES } from "search-filter/constants";
import usePaginationQueryParameter from "hooks/usePaginationQueryParameter";
import usePluggableEntityTableElements from "hooks/usePluggableEntityTableElements";
import { NoEntitiesExist } from "components/common";
import FiltersOverviewItem from "./FiltersOverviewItem";
const FiltersOverview = () => {
  var _a;
  const { page, pageSize, resetPage } = usePaginationQueryParameter();
  const [filterQuery, setSearchFilter] = useState("");
  const { pluggableTableHeaders } = usePluggableEntityTableElements(
    null,
    "search_filter"
  );
  const {
    data: { filters = [], pagination },
    isFetching
  } = useUserSearchFiltersQuery({ query: filterQuery, page, per_page: pageSize, scope: FILTER_SCOPES.ALL });
  const handleSearch = useCallback(
    (newSearchQuery) => {
      setSearchFilter(newSearchQuery);
      resetPage();
    },
    [resetPage, setSearchFilter]
  );
  const handleReset = useCallback(() => {
    handleSearch(void 0);
  }, [handleSearch]);
  const ListHeader = useCallback(
    () => /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Title"), /* @__PURE__ */ React.createElement("th", null, "Query String"), /* @__PURE__ */ React.createElement("th", null, "Description"), pluggableTableHeaders, /* @__PURE__ */ React.createElement("th", { className: "text-right" }, "Actions"))),
    [pluggableTableHeaders]
  );
  return /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { xs: 12 }, /* @__PURE__ */ React.createElement(PaginatedList, { totalItems: (_a = pagination == null ? void 0 : pagination.total) != null ? _a : 0 }, /* @__PURE__ */ React.createElement(
    SearchForm,
    {
      onSearch: handleSearch,
      onReset: handleReset,
      topMargin: 0,
      queryHelpComponent: /* @__PURE__ */ React.createElement(
        QueryHelper,
        {
          entityName: "filter",
          commonFields: ["id", "title", "description"],
          fieldMap: { queryString: "Query string of the filter" }
        }
      )
    }
  ), /* @__PURE__ */ React.createElement(Table, { condensed: true, hover: true, striped: true }, /* @__PURE__ */ React.createElement(ListHeader, null), /* @__PURE__ */ React.createElement("tbody", null, isFetching && /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", { colSpan: 4, "aria-label": "Loading Filters" }, /* @__PURE__ */ React.createElement(Spinner, { delay: 0 }))), filters.length < 1 ? /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", { colSpan: 4, "aria-label": "No search filter found" }, /* @__PURE__ */ React.createElement(NoEntitiesExist, null, "No search filter found."))) : /* @__PURE__ */ React.createElement(React.Fragment, null, filters.map((filter) => /* @__PURE__ */ React.createElement(FiltersOverviewItem, { key: filter.id, filter }))))))));
};
export default FiltersOverview;
